export function preloadImages(scene) {
  // StartScene
  scene.load.image('startBG', 'assets/StartScene/BG.png');
  scene.load.image('play', 'assets/StartScene/play.png');
  scene.load.image('playBlack', 'assets/StartScene/playBlack.png');

  // GameScene background and notepad/pencil
  scene.load.image('gameBG', 'assets/GameScene/BG.png');
  scene.load.image('pencil', 'assets/GameScene/pencil.png');
  scene.load.image('snackbar', 'assets/GameScene/snackbar.png');

  // Toffees (each color has normal + red variant)
  scene.load.image('blue', 'assets/GameScene/blueToffee.png');
  scene.load.image('redBlue', 'assets/GameScene/redBlue.png');
  scene.load.image('purple', 'assets/GameScene/purpleToffee.png');
  scene.load.image('redPurple', 'assets/GameScene/redPurple.png');
  scene.load.image('yellow', 'assets/GameScene/yellowToffee.png');
  scene.load.image('redYellow', 'assets/GameScene/redYellow.png');
  scene.load.image('green', 'assets/GameScene/greenToffee.png');
  scene.load.image('redGreen', 'assets/GameScene/redGreen.png');
  scene.load.image('pink', 'assets/GameScene/pinkToffee.png');
  scene.load.image('redPink', 'assets/GameScene/redPink.png');
  scene.load.image('lightGreen', 'assets/GameScene/lightGreenToffee.png');
  scene.load.image('redLightGreen', 'assets/GameScene/redLightGreen.png');

  // Small bar icons (snack bar tracker)
  scene.load.image('smallBlue', 'assets/GameScene/smallBlue.png');
  scene.load.image('smallPurple', 'assets/GameScene/smallPurple.png');
  scene.load.image('smallYellow', 'assets/GameScene/smallYellow.png');
  scene.load.image('smallGreen', 'assets/GameScene/smallGreen.png');
  scene.load.image('smallPink', 'assets/GameScene/smallPink.png');
  scene.load.image('smallLightGreen', 'assets/GameScene/smallLightGreen.png');
  scene.load.image('shadow', 'assets/GameScene/shadow.png');

  // Plate, notepad and input UI
  scene.load.image('plate', 'assets/GameScene/plate.png');
  scene.load.image('notepad', 'assets/GameScene/notepad.png');
  scene.load.image('notepad2', 'assets/GameScene/notepad2.png');
  scene.load.image('divison', 'assets/GameScene/divison.png');
  scene.load.image('default', 'assets/GameScene/inputDefault.png');
  scene.load.image('typing', 'assets/GameScene/inputTyping.png');
  scene.load.image('correct', 'assets/GameScene/inputCorrect.png');
  scene.load.image('wrong', 'assets/GameScene/inputWrong.png');
  scene.load.image('cursor', 'assets/GameScene/cursor.png');
  scene.load.image('confirm', 'assets/GameScene/confirm.png');
  scene.load.image('confirmBlack', 'assets/GameScene/confirmBlack.png');
}
